<template>
  <GenericDialog :activator="activator" @close="emitClose()">
    <v-card-title> Add new favourite location </v-card-title>
    <FavLocationForm @close="emitClose()" />
  </GenericDialog>
</template>
<script lang="ts">
import Vue from "vue";
import GenericDialog from "../../dialog-wrappers/GenericDialog.vue";
import FavLocationForm from "./FavLocationForm.vue";
export default Vue.extend({
  name: "FavLocationAddDialog",
  components: { GenericDialog, FavLocationForm },
  props: {
    activator: {
      type: Boolean,
    },
  },
  methods: {
    /**
     * Emits a "close" event to the parent component.
     *
     * @return {void}
     */
    emitClose() {
      this.$emit("close");
    },
  },
});
</script>
